import React, { useState, useEffect } from "react";
import { Collapse } from "@mui/material";
import { isEqual } from "lodash";
import classNames from "classnames";

import { createKeyboardShortcut } from "utils/keyboardShortcuts";

import classes from "./style.module.scss";

import ArrowDown from "assets/images/icons/JSX/arrow-down";

const Accordion = React.memo(
    ({
        children,
        heading,
        id = "",
        carbonGrade = null,
        hoverActions = null,
        className,
        headerClassName,
        bodyClassName,
        large = false,
        stats: Stats,
        initOpenState = false,
        isDragging = false,
        isNew = false,
        dragActive = false,
        toggleNew = () => "",
        disabled = false,
        number,
        forceOpen = false,
        forceClose = false,
        // toggleFunction,
    }) => {
        const [open, toggleOpen] = useState(initOpenState);
        const [highlight, toggleHighlight] = useState(isNew);

        const containerClasses = [
            classes.accordion,
            open && !isDragging ? classes.open : "",
            className && className,
            large && classes.large,
            isDragging && classes.dragging,
            highlight && classes.highlight,
            dragActive && classes.dragActive,
            disabled && classes.disabled,
        ].filter((clss) => clss);

        useEffect(() => {
            if (forceClose || isDragging) {
                toggleOpen(false);
                return;
            }

            if (forceOpen) {
                toggleOpen(true);
            } else {
                toggleOpen(initOpenState);
            }
        }, [forceOpen, forceClose, isDragging, initOpenState]);

        useEffect(() => {
            if (forceClose) {
                toggleOpen(false);
            }
        }, [forceClose]);

        const isEnclosure = !!(Stats && hoverActions); //used to prevent width = 100% which would push stats content to the right

        return (
            <div
                className={containerClasses.join(" ")}
                onClick={() => {
                    toggleHighlight(false);
                    if (isNew) {
                        toggleNew();
                    }
                    // console.log(toggleFunction);
                    // if (toggleFunction) {
                    //     toggleFunction()
                    // }
                }}
            >
                <div
                    className={classNames(classes.header, {
                        [classes.hasNumber]: number,
                        [headerClassName]: headerClassName,
                    })}
                    onClick={(e) => {
                        if (e.target.closest?.("[data-selection-checkbox]")) {
                            return;
                        }
                        if (e.target.nodeName === "SPAN" || e.target.nodeName === "INPUT") return;

                        if (e.target.tagName !== "svg") {
                            toggleOpen(!open);
                        }
                    }}
                    {...createKeyboardShortcut({ onKeyDown: () => toggleOpen((prev) => !prev) })}
                >
                    {number && <span className={classes.number}>{number}</span>}
                    <div
                        className={classNames(classes.heading, { [classes.isEnclosure]: isEnclosure, [classes.wrapHeading]: !!carbonGrade })}
                        onClick={(e) => {
                            if (e.target.closest?.("[data-selection-checkbox]")) {
                                return;
                            }
                            e.stopPropagation();
                            toggleOpen(!open);
                        }}
                    >
                        {heading}
                    </div>

                    {Stats && (
                        <div className={classes.stats} onClick={(e) => e.stopPropagation()}>
                            {typeof Stats === "function" ? <Stats /> : Stats}
                        </div>
                    )}
                    {carbonGrade && (
                        <div className={classes.carbonGrade}>
                            {carbonGrade}
                        </div>
                    )}
                    {hoverActions && (
                        <div className={classes.hoverActions} onClick={(e) => e.stopPropagation()}>
                            {hoverActions}
                        </div>
                    )}
                    <div
                        className={classes.toggle}
                        onClick={(e) => {
                            e.stopPropagation();
                            toggleOpen(!open);
                        }}
                    >
                        <ArrowDown />
                    </div>
                </div>
                <Collapse
                    in={open}
                    timeout="auto"
                    unmountOnExit
                    style={{ height: isDragging ? 0 : "auto", overflow: isDragging ? "hidden" : "" }}
                >
                    <div className={classNames(classes.body, { [bodyClassName]: bodyClassName })}>{children}</div>
                </Collapse>
            </div>
        );
    },
    isEqual
);

export default Accordion;
